<div class="container">

    <div class="body">
        <app-btn-actualizar-info *ngIf="actual != 1" style="align-self: flex-end;"></app-btn-actualizar-info >
        <br>
        <div class="form" *ngIf="actual == 1">
            <div>
                <div class="input">
                    <label>Fecha de ingreso</label>
                    <input type="date" matInput [(ngModel)]="AnalisisPF.fecha_creacion" readonly>
                </div>

                <div class="input">
                    <label>Tipo de Comité</label>
                    <mat-select [(ngModel)]="AnalisisPF.tipo_comite" [ngClass]="{'input-required': !AnalisisPF.tipo_comite}">
                        <mat-option value="CARACT. DE LA OPERACIÓN">CARACT. DE LA OPERACIÓN</mat-option>
                        <mat-option value="MONTO SOLICITADO">MONTO SOLICITADO</mat-option>
                    </mat-select>
                </div>

                <div class="input">
                    <label>No. de Comité</label>
                    <input matInput type="number" [(ngModel)]="AnalisisPF.numero_comite" [ngClass]="{'input-required': !(AnalisisPF.numero_comite > 0)}">
                </div>

                <div class="input">
                    <label>Fecha</label>
                    <input type="date" matInput [(ngModel)]="AnalisisPF.cotizacion.fecha_cotizacion" readonly>
                </div>

                <div class="input">
                    <label>Cotización</label>
                    <input type="text" matInput [(ngModel)]="AnalisisPF.cotizacion.cotizacion" readonly>
                </div>

                <div class="input">
                    <label>Nombre</label>
                    <input matInput [(ngModel)]="AnalisisPF.solicitante" readonly>
                </div>

                <div class="input">
                    <label>Actividad económica</label>
                    <input matInput [(ngModel)]="AnalisisPF.actividad_economica">
                </div>
            </div>
            <div>
                <div class="input">
                    <label>Monto a Arrendar</label>
                    <input matInput mask="separator.2" thousandSeparator="," prefix="$ " [(ngModel)]="AnalisisPF.cotizacion.monto_arrendar" readonly>
                </div>

                <div class="input">
                    <label>Activo a Arrendar</label>
                    <input matInput [(ngModel)]="AnalisisPF.caracteristica_activo.descripcion_activo">
                </div>

                <div class="input">
                    <label>Tipo de Activo a Arrendar</label>
                    <input matInput type="text" [(ngModel)]="AnalisisPF.caracteristica_activo.tipo_activo_arrendar" readonly>
                    <!-- <mat-select [(ngModel)]="Analisis.tipo_activo_arrendar" [ngClass]="{'input-required': !Analisis.tipo_activo_arrendar}">
                        <mat-option value="EQUIPO MEDICO">EQUIPO MÉDICO</mat-option>
                        <mat-option value="VEHICULO DE TRANSPORTE">VEHÍCULO DE TRANSPORTE</mat-option>
                        <mat-option value="EQUIPO DE COMPUTO">EQUIPO DE COMPUTO</mat-option>
                        <mat-option value="OTRO">OTRO</mat-option>
                    </mat-select> -->
                    <!-- <span class="input-error" *ngIf="submit == true && !AnalisisPM.tipo_activo_arrendar">Campo obligatorio</span> -->
                </div>

                <div class="input">
                    <label>Ubicación</label>
                    <textarea matInput placeholder="Municipio, Estado" [(ngModel)]="AnalisisPF.caracteristica_activo.domicilio" maxlength="100" [ngClass]="{'input-required': !AnalisisPF.caracteristica_activo.domicilio}" rows="4" style="resize: none; height: 70px;"></textarea>
                    <!-- <span class="input-error" *ngIf="submit == true && !Analisis.domicilio">Campo obligatorio</span> -->
                </div>

                <div class="input textarea-margin">
                    <label>Inicio de Operaciones</label>
                    <input matInput type="date" max="9999-12-31" [(ngModel)]="AnalisisPF.inicio_operaciones" [ngClass]="{'input-required': !AnalisisPF.inicio_operaciones}">
                    <!-- <span class="input-error" *ngIf="submit == true && !Analisis.inicio_operaciones">Campo obligatorio</span> -->
                </div>

                <div class="input inline">
                    <label>Cliente LFU</label>
                    <mat-slide-toggle [(ngModel)]="AnalisisPF.cliente_l4u" (change)="CambiarComportamientoPago(AnalisisPF.id_comportamiento_pago)"></mat-slide-toggle>
                    <!-- <mat-select style="background-color: #EBEBEB;" >
                        <mat-option [value]="true">Sí</mat-option>
                        <mat-option [value]="false">No</mat-option>
                    </mat-select> -->
                </div>

                <div class="input" *ngIf="AnalisisPF.cliente_l4u">
                    <label>Comportamiento de Pago</label>
                    <mat-radio-group #comportamientoPago
                        [ngClass]="{'input-requireed': !AnalisisPF.id_comportamiento_pago}"
                        [(ngModel)]="AnalisisPF.id_comportamiento_pago">
                        <mat-radio-button 
                            *ngFor="let cp of COMPORTAMIENTO_PAGO" 
                            [value]="cp.id"
                            labelPosition="before"
                            (click)="CambiarComportamientoPago(cp.id)">{{ cp.nombre }}</mat-radio-button>
                    </mat-radio-group>
                    <span class="input-error" *ngIf="submit == true && !AnalisisPF.id_comportamiento_pago">Campo obligatorio</span>
                            <!-- <mat-select style="background-color: #EBEBEB;" 
                                #comportamientoPago 
                                [ngClass]="{'input-requireed': !Analisis.id_comportamiento_pago}"
                                [(ngModel)]="Analisis.id_comportamiento_pago"
                                (selectionChange)="CambiarComportamientoPago($event.value)">
                                <mat-option *ngFor="let cp of COMPORTAMIENTO_PAGO" [value]="cp.id">{{ cp.nombre }}</mat-option>
                            </mat-select> -->
                </div>
            </div>
        </div>
        <div *ngIf="actual == 1" class="puntuacion">{{ AnalisisPF.caracter.puntuacion_comportamiento_pago }} puntos</div>     


        <div class="form" *ngIf="actual == 1">
            <div>
                <div class="title-section"><span class="circle">1</span><b>Perfil <br>del solicitante</b></div>
                <div class="precalificar-contacto">{{ObtenerNombre(false)}} <span (click)="Editar(contactoSolicitante)"><mat-icon>edit</mat-icon></span><span (click)="Precalificar(contactoSolicitante)"><mat-icon>badge</mat-icon></span></div>
                <tbody class="formulario analisis solicitante">
                    <tr>
                        <td></td>
                        <td>Calificar</td>
                        <td></td>
                        <td>Puntuación</td>
                    </tr>
                    <tr>
                        <td>
                            BC<br> 
                            Score 
                            <svg *ngIf="AnalisisPF.perfil_solicitante.bc_score" (click)="InfoBuro()" style="height: 15px; width: auto;" xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 17.328 17.328"><defs><style>.info_icon_2{ fill: white; stroke: #3F4A57; stroke-width: 2px;}</style></defs><path class="info_icon_2" d="M10.664,2a8.664,8.664,0,1,0,8.664,8.664A8.664,8.664,0,0,0,10.664,2Zm.866,13H9.8V13.263H11.53Zm0-3.466H9.8v-5.2H11.53Z" transform="translate(-2 -2)"/></svg>
                        </td>
                        <td><input 
                            matInput 
                            [(ngModel)]="AnalisisPF.perfil_solicitante.bc_score" 
                            #solicitanteBcScore 
                            type="number"
                            (input)="CambiarPuntuacionSolicitante()">
                        <mat-error *ngIf="submit && !(AnalisisPF.perfil_solicitante.bc_score > 0)">Campo obligatorio</mat-error></td>
                        <td><input matInput [(ngModel)]="AnalisisPF.perfil_solicitante.bc_score_descrip" readonly></td>
                        <td><input #solBc matInput [(ngModel)]="AnalisisPF.perfil_solicitante.bc_score_punt" (input)="ActualizarPuntuacion('perfil_solicitante')"></td>
                    </tr>
                    <!-- <tr>
                        <td>ICC</td>
                        <td><input 
                            matInput 
                            [(ngModel)]="Analisis.perfil_solicitante.icc" 
                            #solicitanteIcc
                            type="number"
                            (input)="CambiarPuntuacionSolicitante()"></td>
                        <td><input matInput [(ngModel)]="Analisis.perfil_solicitante.icc_descrip" readonly></td>
                        <td><input #solIcc matInput [(ngModel)]="Analisis.perfil_solicitante.icc_punt" (input)="ActualizarPuntuacion('perfil_solicitante')"></td>
                    </tr> -->
                    <tr>
                        <td>Arraigo <br>en Domicilio</td>
                        <td><input 
                            matInput 
                            [value]="AnalisisPF.perfil_solicitante.arraigo_domicilio"
                            [(ngModel)]="AnalisisPF.perfil_solicitante.arraigo_domicilio" 
                            #arraigoDomicilio
                            type="text"
                            readonly
                            (input)="CambiarPuntuacionSolicitante()"
                            ></td>
                        <td><input matInput [(ngModel)]="AnalisisPF.perfil_solicitante.arraigo_domicilio_descrip" readonly></td>
                        <td><input #solArraigoDomicilio matInput [(ngModel)]="AnalisisPF.perfil_solicitante.arraigo_domicilio_punt" (input)="ActualizarPuntuacion('perfil_solicitante')"></td>
                    </tr>
                    <tr>
                        <td>Arraigo <br>en Empleo</td>
                        <td><input 
                            matInput 
                            [(ngModel)]="AnalisisPF.perfil_solicitante.arraigo_empleo" 
                            #arraigoEmpleo
                            type="number"
                            [value]="AnalisisPF.perfil_solicitante.arraigo_empleo"
                            (input)="CambiarPuntuacionSolicitante()"></td>
                        <td><input matInput [(ngModel)]="AnalisisPF.perfil_solicitante.arraigo_empleo_descrip" readonly></td>
                        <td><input #solArraigoEmpleo matInput [(ngModel)]="AnalisisPF.perfil_solicitante.arraigo_empleo_punt" (input)="ActualizarPuntuacion('perfil_solicitante')"></td>
                    </tr>
                    <tr>
                        <td>Consejo de <br>Especialidad</td>
                        <td><mat-select 
                            [(ngModel)]="AnalisisPF.perfil_solicitante.consejo_especialidad"
                            (selectionChange)="CambiarPuntuacionSolicitante()">
                            <mat-option [value]="'SI'">Sí</mat-option>
                            <mat-option [value]="'NO'">No</mat-option>
                        </mat-select></td>
                        <td><input matInput [(ngModel)]="AnalisisPF.perfil_solicitante.consejo_especialidad_descrip" readonly></td>
                        <td><input #solConsejoEspecialidad matInput [(ngModel)]="AnalisisPF.perfil_solicitante.consejo_especialidad_punt" (input)="ActualizarPuntuacion('perfil_solicitante')"></td>
                    </tr>
                    <tr>
                        <td></td>
                        <td></td>
                        <td colspan="2" style="text-align: right;">
                            <div class="puntuacion small">{{AnalisisPF.perfil_solicitante.total}} puntos</div>
                            <!-- <input #puntosTotalSolicitante
                            matInput readonly
                            [(ngModel)]="Analisis.perfil_solicitante.total"
                            style="background-color: #838483; color:white; font-size:1.3rem;text-align:center; width: 200px; margin-left: 5px;"> -->
                        </td>
                    </tr>
                </tbody>
            </div>
            <div>
                <div class="title-section"><span class="circle">2</span><b>Perfil <br>del aval</b></div>
                <div class="precalificar-contacto">{{ObtenerNombre(true)}} <span (click)="Editar(contactoAval, true)"><mat-icon>edit</mat-icon></span><span (click)="Precalificar(contactoAval)"><mat-icon>badge</mat-icon></span></div>
                <tbody class="formulario analisis">
                    <!-- <tr>
                        <td>Nombre</td>
                        <td colspan="3"><input matInput [(ngModel)]="AnalisisPF.perfil_aval.nombre" readonly></td>
                    </tr> -->
                    <tr>
                        <td></td>
                        <td>Calificar</td>
                        <td></td>
                        <td>Puntuación</td>
                    </tr>
                    <tr>
                        <td>BC <br>Score</td>
                        <td><input 
                            matInput 
                            [(ngModel)]="AnalisisPF.perfil_aval.bc_score" 
                            #avalBcScore
                            type="number"
                            (input)="CambiarPuntuacionAval()">
                        <!-- <mat-error *ngIf="submit && !(AnalisisPF.perfil_aval.bc_score > 0)">Campo obligatorio</mat-error></td> -->
                        <td><input matInput [(ngModel)]="AnalisisPF.perfil_aval.bc_score_descrip" readonly></td>
                        <td><input #avalBc matInput [(ngModel)]="AnalisisPF.perfil_aval.bc_score_punt" (input)="ActualizarPuntuacion('perfil_aval')"></td>
                    </tr>
                    <!-- <tr>
                        <td>ICC</td>
                        <td><input 
                            matInput 
                            [(ngModel)]="Analisis.perfil_aval.icc" 
                            #avalIcc
                            type="number"
                            (input)="CambiarPuntuacionAval()"></td>
                        <td><input matInput [(ngModel)]="Analisis.perfil_aval.icc_descrip" readonly></td>
                        <td><input #avalIccPoints matInput [(ngModel)]="Analisis.perfil_aval.icc_punt" (input)="ActualizarPuntuacion('perfil_aval')"></td>
                    </tr> -->
                    <!-- <tr>
                        <td>Documentación</td>
                        <td><mat-select 
                            [(ngModel)]="Analisis.perfil_aval.documentacion"
                            (selectionChange)="CambiarPuntuacionAval()">
                            <mat-option></mat-option>
                            <mat-option value="OK">OK</mat-option>
                        </mat-select></td>
                        <td><input matInput [(ngModel)]="Analisis.perfil_aval.documentacion_descrip" readonly></td>
                        <td><input #avalDocumentacion matInput [(ngModel)]="Analisis.perfil_aval.documentacion_punt" (input)="ActualizarPuntuacion('perfil_aval')"></td>
                    </tr> -->
                    <tr>
                        <td>Parentesco</td>
                        <td colspan="3"><input style="width: 95%;" readonly matInput [(ngModel)]="AnalisisPF.aval.aval_parentezco"></td>
                        <!-- <td><input matInput [(ngModel)]="Analisis.perfil_aval.parentezco_descrip" readonly></td>
                        <td><input #avalParentezco matInput [(ngModel)]="Analisis.perfil_aval.parentezco_punt" (input)="ActualizarPuntuacion('perfil_aval')"></td> -->
                    </tr>
                    <tr>
                        <td>Ocupación</td>
                        <td colspan="3"><input style="width: 95%;" readonly matInput [(ngModel)]="AnalisisPF.aval.aval_ocupacion"></td>
                        <!-- <td><input matInput [(ngModel)]="Analisis.perfil_aval.ocupacion_descrip" readonly></td>
                        <td><input #avalOcupacion matInput [(ngModel)]="Analisis.perfil_aval.ocupacion_punt" (input)="ActualizarPuntuacion('perfil_aval')"></td> -->
                    </tr>
                    <tr>
                        <td></td>
                        <td></td>
                        <!-- <td colspan="2" style="text-align: right;">PUNTOS<input #puntosTotalAval
                            matInput readonly
                            [(ngModel)]="Analisis.perfil_aval.total"
                            [value]="(avalBc.value *1) + (avalIccPoints.value *1) + (avalDocumentacion.value *1) + (avalParentezco.value *1) + (avalOcupacion.value *1)"
                            style="background-color: #838483; color:white; font-size:1.3rem;text-align:center;  width: 200px; margin-left: 5px;"
                            ></td>  -->
                        <td colspan="2" style="text-align: right;">
                            <div class="puntuacion small">{{AnalisisPF.perfil_aval.total}} puntos</div>
                            <!-- <input #puntosTotalSolicitante
                            matInput readonly
                            [(ngModel)]="Analisis.perfil_aval.total"
                            style="background-color: #838483; color:white; font-size:1.3rem;text-align:center; width: 200px; margin-left: 5px;"> -->
                        </td>
                    </tr>
                </tbody>
            </div>
            <div style="width: 100%!important;">
                <div class="title-section"><span class="circle">3</span><b>Resumen del <br>Historial de Crédito</b></div><div></div>
                <div style="display: flex; flex-direction: column; width: 90%!important;">
                    <div style="display: flex; flex-direction: row; justify-content: flex-start; align-items: flex-start;">
                        <tbody class="formulario analisis">
                            <tr>
                                <th style="width: 130px;">Cuentas Activas</th>
                                <th>Monto</th>
                                <th>Saldo insoluto</th>
                                <th>Mop Máximo</th>
                                <th>Comp. de pago</th>
                                <th>Puntuación</th>
                            </tr>
                            <tr *ngFor="let credito of AnalisisPF.historial_credito.activas; let idx = index;">
                                <td>
                                    <mat-select [(ngModel)]="credito.tipo_credito" placeholder="Seleccionar...">
                                        <mat-option value="Aparatos /Muebles">Aparatos /Muebles</mat-option>
                                        <mat-option value="Agropecuario (PFAE)">Agropecuario (PFAE)</mat-option>
                                        <mat-option value="Arrendamiento Automotriz">Arrendamiento Automotriz</mat-option>
                                        <mat-option value="Aviación">Aviación</mat-option>
                                        <mat-option value="Compra de Automóvil">Compra de Automóvil</mat-option>
                                        <mat-option value="Fianza">Fianza</mat-option>
                                        <mat-option value="Bote / Lancha">Bote / Lancha</mat-option>
                                        <mat-option value="Tarjeta de Crédito">Tarjeta de Crédito</mat-option>
                                        <mat-option value="Cartas de Crédito (PFAE)">Cartas de Crédito (PFAE)</mat-option>
                                        <mat-option value="Crédito fiscal">Crédito fiscal</mat-option>
                                        <mat-option value="Línea de Crédito">Línea de Crédito</mat-option>
                                        <mat-option value="Consolidación">Consolidación</mat-option>
                                        <mat-option value="Crédito Simple (PFAE)">Crédito Simple (PFAE)</mat-option>
                                        <mat-option value="Con Colateral (PFAE)">Con Colateral (PFAE)</mat-option>
                                        <mat-option value="Descuentos (PFAE)">Descuentos (PFAE)</mat-option>
                                        <mat-option value="Equipo">Equipo</mat-option>
                                        <mat-option value="Fideicomiso (PFAE)">Fideicomiso (PFAE)</mat-option>
                                        <mat-option value="Factoraje">Factoraje</mat-option>
                                        <mat-option value="Habilitación o Avío (PFAE)">Habilitación o Avío (PFAE)</mat-option>
                                        <mat-option value="Préstamo tipo “Home Equity”">Préstamo tipo “Home Equity”</mat-option>
                                        <mat-option value="Mejoras a la casa">Mejoras a la casa</mat-option>
                                        <mat-option value="Línea de Crédito Reinstalable">Línea de Crédito Reinstalable</mat-option>
                                        <mat-option value="Arrendamiento">Arrendamiento</mat-option>
                                        <mat-option value="Otros adeudos vencidos (PFAE)">Otros adeudos vencidos (PFAE)</mat-option>
                                        <mat-option value="Préstamo para Personas Físicas con Actividad Empresarial (PFAE)">Préstamo para Personas Físicas con Actividad Empresarial (PFAE)</mat-option>
                                        <mat-option value="Editorial">Editorial</mat-option>
                                        <mat-option value="PGUE - Préstamo como garantía de unidades industriales para PFAE">PGUE - Préstamo como garantía de unidades industriales para PFAE</mat-option>
                                        <mat-option value="Préstamo personal">Préstamo personal</mat-option>
                                        <mat-option value="Préstamo de nómina">Préstamo de nómina</mat-option>
                                        <mat-option value="Prendario (PFAE)">Prendario (PFAE)</mat-option>
                                        <mat-option value="Pago de Servicios">Pago de Servicios</mat-option>
                                        <mat-option value="Quirografario (PFAE)">Quirografario (PFAE)</mat-option>
                                        <mat-option value="Reestructurado (PFAE)">Reestructurado (PFAE)</mat-option>
                                        <mat-option value="Redescuento (PFAE)">Redescuento (PFAE)</mat-option>
                                        <mat-option value="Bienes Raíces">Bienes Raíces</mat-option>
                                        <mat-option value="Refaccionario (PFAE)">Refaccionario (PFAE)</mat-option>
                                        <mat-option value="Renovado (PFAE)">Renovado (PFAE)</mat-option>
                                        <mat-option value="Vehículo Recreativo">Vehículo Recreativo</mat-option>
                                        <mat-option value="Tarjeta garantizada">Tarjeta garantizada</mat-option>
                                        <mat-option value="Préstamo garantizado">Préstamo garantizado</mat-option>
                                        <mat-option value="Seguros">Seguros</mat-option>
                                        <mat-option value="Segunda hipoteca">Segunda hipoteca</mat-option>
                                        <mat-option value="Préstamo para estudiante">Préstamo para estudiante</mat-option>
                                        <mat-option value="Tarjeta de Crédito Empresarial">Tarjeta de Crédito Empresarial</mat-option>
                                        <mat-option value="Préstamo no garantizado">Préstamo no garantizado</mat-option>
                                    </mat-select>
                                </td>
                                <td>
                                    <input matInput mask="separator.2" thousandSeparator="," prefix="$ " [(ngModel)]="credito.monto">
                                </td>
                                <td>
                                    <input matInput mask="separator.2" thousandSeparator="," [(ngModel)]="credito.saldo_insoluto">
                                </td>
                                <td>
                                    <input matInput mask="separator.2" thousandSeparator="," [(ngModel)]="credito.mop_max">
                                </td>
                                <td>
                                    <mat-select 
                                        [(ngModel)]="credito.id_comportamiento_pago"
                                        (selectionChange)="CambiarComportamientoPagoCredito( 'activas', idx )">
                                        <mat-option *ngFor="let cp of COMPORTAMIENTO_PAGO_CREDITO" [value]="cp.id">{{ cp.nombre }}</mat-option>
                                    </mat-select>
                                </td>
                                <td class="centrar-texto">
                                    {{credito.puntuacion}} puntos
                                    <!-- <input matInput [(ngModel)]="credito.puntuacion" readonly style="border: none;"> -->
                                </td>
                                <td>
                                    <button class="button-del" mat-icon-button (click)="BorrarCuenta('activas', idx)"><mat-icon>delete</mat-icon></button>
                                </td>
                            </tr>
                        </tbody>
                        <button class="button-add" *ngIf="AnalisisPF.historial_credito.activas.length < 10" mat-icon-button style="align-self: flex-end; margin-left: 12px;" (click)="AgregarCuenta('activas')"><mat-icon>add</mat-icon></button>
                    </div>
                    <span class="puntuacion small" style="align-self: flex-end;">{{AnalisisPF.puntos_credito_abierto}} puntos</span>
                    <div style="display: flex; flex-direction: row; justify-content: flex-start; align-items: flex-start;">
                    <tbody  class="formulario analisis" style="margin-top: 20px;">
                        <!-- <tr>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td colspan="2" style="text-align: right;">PUNTOS
                                <input readonly matInput [(ngModel)]="Analisis.puntos_credito_abierto" style="background-color: #838483; color:white; font-size:1.3rem;text-align:center; width: 200px; margin-left: 5px;"></td>
                        </tr> -->
                        <tr>
                            <th style="width: 130px;">Cuentas Cerradas</th>
                            <th>Monto</th>
                            <th>Saldo insoluto</th>
                            <th>Mop Máximo</th>
                            <th>Comp de pago</th>
                            <th>Puntuación</th>
                        </tr>
                        <tr *ngFor="let credito of AnalisisPF.historial_credito.cerradas; let idx = index;">
                            <td>
                                <mat-select [(ngModel)]="credito.tipo_credito" placeholder="Seleccionar...">
                                    <mat-option value="Aparatos /Muebles">Aparatos /Muebles</mat-option>
                                        <mat-option value="Agropecuario (PFAE)">Agropecuario (PFAE)</mat-option>
                                        <mat-option value="Arrendamiento Automotriz">Arrendamiento Automotriz</mat-option>
                                        <mat-option value="Aviación">Aviación</mat-option>
                                        <mat-option value="Compra de Automóvil">Compra de Automóvil</mat-option>
                                        <mat-option value="Fianza">Fianza</mat-option>
                                        <mat-option value="Bote / Lancha">Bote / Lancha</mat-option>
                                        <mat-option value="Tarjeta de Crédito">Tarjeta de Crédito</mat-option>
                                        <mat-option value="Cartas de Crédito (PFAE)">Cartas de Crédito (PFAE)</mat-option>
                                        <mat-option value="Crédito fiscal">Crédito fiscal</mat-option>
                                        <mat-option value="Línea de Crédito">Línea de Crédito</mat-option>
                                        <mat-option value="Consolidación">Consolidación</mat-option>
                                        <mat-option value="Crédito Simple (PFAE)">Crédito Simple (PFAE)</mat-option>
                                        <mat-option value="Con Colateral (PFAE)">Con Colateral (PFAE)</mat-option>
                                        <mat-option value="Descuentos (PFAE)">Descuentos (PFAE)</mat-option>
                                        <mat-option value="Equipo">Equipo</mat-option>
                                        <mat-option value="Fideicomiso (PFAE)">Fideicomiso (PFAE)</mat-option>
                                        <mat-option value="Factoraje">Factoraje</mat-option>
                                        <mat-option value="Habilitación o Avío (PFAE)">Habilitación o Avío (PFAE)</mat-option>
                                        <mat-option value="Préstamo tipo “Home Equity”">Préstamo tipo “Home Equity”</mat-option>
                                        <mat-option value="Mejoras a la casa">Mejoras a la casa</mat-option>
                                        <mat-option value="Línea de Crédito Reinstalable">Línea de Crédito Reinstalable</mat-option>
                                        <mat-option value="Arrendamiento">Arrendamiento</mat-option>
                                        <mat-option value="Otros adeudos vencidos (PFAE)">Otros adeudos vencidos (PFAE)</mat-option>
                                        <mat-option value="Préstamo para Personas Físicas con Actividad Empresarial (PFAE)">Préstamo para Personas Físicas con Actividad Empresarial (PFAE)</mat-option>
                                        <mat-option value="Editorial">Editorial</mat-option>
                                        <mat-option value="PGUE - Préstamo como garantía de unidades industriales para PFAE">PGUE - Préstamo como garantía de unidades industriales para PFAE</mat-option>
                                        <mat-option value="Préstamo personal">Préstamo personal</mat-option>
                                        <mat-option value="Préstamo de nómina">Préstamo de nómina</mat-option>
                                        <mat-option value="Prendario (PFAE)">Prendario (PFAE)</mat-option>
                                        <mat-option value="Pago de Servicios">Pago de Servicios</mat-option>
                                        <mat-option value="Quirografario (PFAE)">Quirografario (PFAE)</mat-option>
                                        <mat-option value="Reestructurado (PFAE)">Reestructurado (PFAE)</mat-option>
                                        <mat-option value="Redescuento (PFAE)">Redescuento (PFAE)</mat-option>
                                        <mat-option value="Bienes Raíces">Bienes Raíces</mat-option>
                                        <mat-option value="Refaccionario (PFAE)">Refaccionario (PFAE)</mat-option>
                                        <mat-option value="Renovado (PFAE)">Renovado (PFAE)</mat-option>
                                        <mat-option value="Vehículo Recreativo">Vehículo Recreativo</mat-option>
                                        <mat-option value="Tarjeta garantizada">Tarjeta garantizada</mat-option>
                                        <mat-option value="Préstamo garantizado">Préstamo garantizado</mat-option>
                                        <mat-option value="Seguros">Seguros</mat-option>
                                        <mat-option value="Segunda hipoteca">Segunda hipoteca</mat-option>
                                        <mat-option value="Préstamo para estudiante">Préstamo para estudiante</mat-option>
                                        <mat-option value="Tarjeta de Crédito Empresarial">Tarjeta de Crédito Empresarial</mat-option>
                                        <mat-option value="Préstamo no garantizado">Préstamo no garantizado</mat-option>
                                </mat-select>
                            </td>
                            <td>
                                <input matInput mask="separator.2" thousandSeparator="," prefix="$ " [(ngModel)]="credito.monto">
                            </td>
                            <td>
                                <input matInput mask="separator.2" thousandSeparator="," [(ngModel)]="credito.saldo_insoluto">
                            </td>
                            <td>
                                <input matInput mask="separator.2" thousandSeparator="," [(ngModel)]="credito.mop_max">
                            </td>
                            <td>
                                <mat-select 
                                    [(ngModel)]="credito.id_comportamiento_pago"
                                    (selectionChange)="CambiarComportamientoPagoCredito( 'cerradas', idx )">
                                    <mat-option *ngFor="let cp of COMPORTAMIENTO_PAGO_CREDITO" [value]="cp.id">{{ cp.nombre }}</mat-option>
                                </mat-select>
                            </td>
                            <td class="centrar-texto">
                                {{credito.puntuacion}} puntos
                                <!-- <input matInput [(ngModel)]="credito.puntuacion"  readonly style="border: none;"> -->
                            </td>
                            <td>
                                <button class="button-del" mat-icon-button (click)="BorrarCuenta('cerradas', idx)"><mat-icon>delete</mat-icon></button>
                            </td>
                        </tr>
                        <!-- <tr>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td colspan="2" style="text-align: right;">PUNTOS<input readonly matInput [(ngModel)]="Analisis.puntos_credito_cerradas" style="background-color: #838483; color:white; font-size:1.3rem;text-align:center; width: 200px; margin-left: 5px;"></td>
                        </tr> -->
                    </tbody>
                    <button class="button-add" *ngIf="AnalisisPF.historial_credito.cerradas.length < 10" mat-icon-button style="align-self: flex-end; margin-left: 12px;" (click)="AgregarCuenta('cerradas')"><mat-icon>add</mat-icon></button>
                </div>
                <span class="puntuacion small" style="align-self: flex-end;">{{AnalisisPF.puntos_credito_cerradas}} puntos</span>
                </div>
            </div>

            <div>
                <div class="title-section"><span class="circle">4</span></div><div></div>
                <div class="formulario analisis">
                    <div class="input">
                        <label>Egresado de</label>
                        <input matInput [(ngModel)]="AnalisisPF.nombre_escuela_egresado"  style="width: 300px; background-color: white; border:1px solid #000000;">
                        <mat-error *ngIf="submit && !AnalisisPF.nombre_escuela_egresado">Campo obligatorio</mat-error>
                    </div>
                    <div class="input">
                        <label>Especialidad</label>
                        <input matInput [(ngModel)]="AnalisisPF.especialidad" style="width: 300px; background-color: white; border:1px solid #000000;">
                        <!-- <mat-error *ngIf="submit && !Analisis.especialidad">Campo obligatorio</mat-error> -->
                    </div>
                    <div class="input">
                        <label>Residencia</label>
                        <input matInput [(ngModel)]="AnalisisPF.residencia_escuela" style="width: 300px; background-color: white; border:1px solid #000000;">
                        <!-- <mat-error *ngIf="submit && !Analisis.residencia_escuela">Campo obligatorio</mat-error> -->
                    </div>
                </div>
            </div>
            <div>
                <div class="title-section"><span class="circle">5</span><b>Puntuacion final</b></div><div></div>
                <div>
                    <div class="puntuacion" style="margin-left:auto;">{{AnalisisPF.puntuacion_caracter}} / 34 puntos</div>
                    <!-- <h2>Comentarios de caracter</h2>
                    <textarea maxlength="500" placeholder="Comentarios" [(ngModel)]="AnalisisPF.caracter.comentarios_caracter" style="width: 100%;" rows="5"></textarea> -->
                </div>
            </div>
        </div>


        <div class="form" *ngIf="actual == 1">
            <div><span class="circle">1</span>
                <!-- <mat-error *ngIf="submit && !(Analisis.promedio_depositos > 0)">Campos obligatorios</mat-error> -->
            </div><div></div>

            <div style="width: 100%; display: flex; flex-direction: row; justify-content: flex-start;">
                <tbody class="formulario analisis" style="width: 80%;">
                    <tr>
                        <td>Ajuste de saldo</td>
                        <td><input [(ngModel)]="AnalisisPF.saldo_inicial" matInput mask="separator.2" thousandSeparator="," prefix="$ " (input)="ActualizarPromedios()"></td>
                        <td colspan="2"></td>
                    </tr>
                    <tr>
                        <th style="width: 150px;">Mes</th>
                        <th>Depositos</th>
                        <th>Retiros</th>
                        <th>Saldo Final</th>
                    </tr>
                    <tr *ngFor="let movimiento of AnalisisPF.historial_movimientos; let idx = index">
                        <td>
                            <mat-select [(ngModel)]="movimiento.mes">
                                <mat-option *ngFor="let mes of MESES" [value]="mes">{{ mes }}</mat-option>
                            </mat-select>
                        </td>
                        <td><input matInput mask="separator.2" thousandSeparator="," prefix="$ " (input)="ActualizarPromedios()" [(ngModel)]="movimiento.depositos"></td>
                        <td><input matInput mask="separator.2" thousandSeparator="," prefix="$ " (input)="ActualizarPromedios()" [(ngModel)]="movimiento.gastos"></td>
                        <td><input [allowNegativeNumbers]="true" mask="separator.2" thousandSeparator="," prefix="$ " matInput (input)="ActualizarPromedios()" [(ngModel)]="movimiento.saldo_final"></td>
                        <td><button *ngIf="AnalisisPF.historial_movimientos.length > 1" mat-icon-button class="button-del" (click)="BorrarMovimiento(idx)"><mat-icon>delete</mat-icon></button></td>
                    </tr>
                    <tr>
                        <td style="text-align: right;padding-right: 8px; box-sizing: border-box;">Promedio </td>
                        <td><input mask="separator.2" thousandSeparator="," prefix="$ " matInput readonly [ngModel]="AnalisisPF.promedio_depositos | number:'1.2-2'" (ngModelChange)="AnalisisPF.promedio_depositos=$event"  style="background-color: #C4C4C4; font-size: 1.3;"></td>
                        <td><input mask="separator.2" thousandSeparator="," prefix="$ " matInput readonly [ngModel]="AnalisisPF.promedio_gastos | number:'1.2-2'" (ngModelChange)="AnalisisPF.promedio_gastos=$event" style="background-color: #C4C4C4; font-size: 1.3;"></td>
                        <td><input mask="separator.2" thousandSeparator="," prefix="$ " matInput readonly [ngModel]="AnalisisPF.promedio_saldo_final | number:'1.2-2'" (ngModelChange)="AnalisisPF.promedio_saldo_final=$event" style="background-color: #C4C4C4; font-size: 1.3;"></td>
                    </tr>
                </tbody>
                <button *ngIf="AnalisisPF.historial_movimientos.length < 12" (click)="AgregarMovimiento()" mat-icon-button class="button-add" style="align-self: flex-end; margin-bottom: 40px;"><mat-icon>add</mat-icon></button>
            </div>

            <div><span class="circle">2</span></div><div></div>
            <div>
                <div class="input">
                    <label>Ingresos en Nómina</label>
                    <input matInput mask="separator.2" thousandSeparator="," prefix="$ " [(ngModel)]="AnalisisPF.capacidad_pago.ingresos_nomina" (input)="ActualizarPromedios()">
                </div>
                <div class="input">
                    <label>Ingresos en Efectivo</label>
                    <input matInput mask="separator.2" thousandSeparator="," prefix="$ " [(ngModel)]="AnalisisPF.capacidad_pago.ingresos_efectivo" readonly>
                </div>
            </div>

            <div>
                <div class="input">
                    <label>Ingresos Extras</label>
                    <input matInput mask="separator.2" thousandSeparator="," prefix="$ " [(ngModel)]="AnalisisPF.capacidad_pago.ingresos_extra" readonly>
                </div>
            </div>

            <div class="title-action"><span class="circle">3</span><b>Matriz de cálculo <br>Capacidad de Pago</b></div>

            <div style="width: 100%!important; display: flex; flex-direction: row;">
                <tbody class="formulario analisis">
                    <tr>
                        <th></th>
                        <th>Ingresos</th>
                        <th>Gastos</th>
                        <th>Factor %</th>
                    </tr>
                    <tr>
                        <td>Comprobables (A)</td>
                        <td><input matInput [ngModel]="AnalisisPF.capacidad_pago.comprobantes_ingresos | number:'.2-2'" readonly (ngModelChange)="AnalisisPF.capacidad_pago.comprobantes_ingresos= $event" readonly></td>
                        <td><input matInput [ngModel]="AnalisisPF.capacidad_pago.comprobantes_gastos | number:'.2-2'" (ngModelChange)="AnalisisPF.capacidad_pago.comprobantes_gastos= $event" readonly></td>
                        <td><input matInput [ngModel]="AnalisisPF.capacidad_pago.comprobantes_factor" (ngModelChange)="AnalisisPF.capacidad_pago.comprobantes_factor= $event" readonly></td>
                    </tr>
                    <tr>
                        <td>En Efectivo (B)</td>
                        <td><input matInput [ngModel]="AnalisisPF.capacidad_pago.efectivo_ingresos | number:'.2-2'" readonly (ngModelChange)="AnalisisPF.capacidad_pago.efectivo_ingresos= $event" readonly></td>
                        <td><input matInput [ngModel]="AnalisisPF.capacidad_pago.efectivo_gastos | number:'.2-2'" (ngModelChange)="AnalisisPF.capacidad_pago.efectivo_gastos= $event" readonly></td>
                        <td><input matInput [ngModel]="AnalisisPF.capacidad_pago.efectivo_factor" (ngModelChange)="AnalisisPF.capacidad_pago.efectivo_factor= $event" readonly></td>
                    </tr>
                    <tr>
                        <td>Extra Nuevo Equipo (C)</td>
                        <td><input matInput #extraEquipoNvoIngreso [ngModel]="AnalisisPF.capacidad_pago.extra_nuevo_equipo_ingresos | number:'.2-2'" readonly (ngModelChange)="AnalisisPF.capacidad_pago.extra_nuevo_equipo_ingresos= $event"></td>
                        <td><input matInput #extraEquipoNvoGasto [ngModel]="(AnalisisPF.capacidad_pago.extra_nuevo_equipo_gastos) | number:'.2-2'" (ngModelChange)="AnalisisPF.capacidad_pago.extra_nuevo_equipo_gastos= $event" readonly></td>
                        <td><input matInput [ngModel]="AnalisisPF.capacidad_pago.extra_nuevo_equipo_factor" (ngModelChange)="AnalisisPF.capacidad_pago.extra_nuevo_equipo_factor=$event" readonly></td>
                    </tr>
                    <!-- <tr>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td><h2><span>MAX {{ Analisis.maximo_factor}}%</span></h2></td>
                    </tr> -->
                    <tr>
                        <td>Factor de Renta</td>
                        <td colspan="2"><input matInput type="number" [(ngModel)]="AnalisisPF.capacidad_pago.factor_renta" readonly></td>
                        <td></td>
                    </tr>
                    <tr>
                        <td>Renta Adicional</td>
                        <td colspan="2"><input matInput type="number" [(ngModel)]="AnalisisPF.capacidad_pago.renta_adicional_disponible" readonly></td>
                        <td></td>
                    </tr>
                </tbody>
                <span class="puntuacion">Valor Óptimo<br>{{ AnalisisPF.capacidad_pago.maximo_factor}}%</span>
            </div>

            <div class="title-sectio"><span class="circle">4</span><b>Puntuacion final</b></div> <div></div>
            <div style="width: 20%!important;">
                <input mask="00 puntos/33" suffix="/33" style="text-align: center; outline: none;" class="puntuacion small" #puntuacionCapacidadPago  [(ngModel)]="AnalisisPF.capacidad_pago.puntuacion_capacidad_pago">
            </div>
            <!-- <div style="width: 70%!important;">
                <div class="input">
                    <label for="Comentarios de capacidad de pago"></label>
                    <textarea maxlength="500" placeholder="comentarios" [(ngModel)]="AnalisisPF.capacidad_pago.comentarios_capacidad_pago" rows="4"></textarea> -->
                    <!-- <mat-error *ngIf="submit && !Analisis.comentarios_capacidad_pago">Campo obligatorio</mat-error> -->
                <!-- </div>
            </div> -->
        </div>

        <div class="form" *ngIf="actual === 1">
            <div class="title-section"><span class="circle">1</span><b>Caracteristica<br>del activo</b></div><div></div>
            <div>
                <div class="input">
                    <label>Activo solicitado</label>
                    <input matInput style="width: 400px;" [(ngModel)]="AnalisisPF.caracteristica_activo.descripcion_activo">
                </div>
            </div>

            <div>
                <div class="input">
                    <label>Monto</label>
                    <input mask="separator.2" thousandSeparator="," prefix="$ " matInput [(ngModel)]="AnalisisPF.cotizacion.monto_arrendar" readonly>
                </div>
            </div>
            <div><span class="circle">2</span></div><div></div>

            <div>
                <div class="input">
                    <label>Vendor</label>
                    <input [(ngModel)]="AnalisisPF.cotizacion.vendor">
                </div>
                <mat-radio-group [(ngModel)]="AnalisisPF.cotizacion.tipo_vendor">
                    <mat-radio-button style="width: 40%;" labelPosition="before" [value]="'Interno'">Interno</mat-radio-button>
                    <mat-radio-button labelPosition="before" [value]="'Externo'">Externo</mat-radio-button>
                </mat-radio-group>
                <!-- <mat-error *ngIf="submit && !Analisis.tipo_vendor">Campo obligatorio</mat-error> -->

                <div class="input">
                    <label for="Comercial">Comercial</label>
                    <input type="text" [patterns]="customPattern" mask="S{100}" [specialCharacters]="['space']" [(ngModel)]="AnalisisPF.cotizacion.comercial">
                    <!-- <mat-select [(ngModel)]="Analisis.comercial"  name="Comercial" ngDefaultControl>
                        <mat-option [value]="''">Selecciona</mat-option>
                        <mat-option *ngFor="let item of COMERCIAL_LIST" [value]="item">{{item}}</mat-option>
                    </mat-select>  -->
                    <!-- <mat-error *ngIf="submit && !AnalisisPF..comercial">Campo obligatorio</mat-error> -->
                </div>

                <div class="input">
                    <label>Marca</label>
                    <input [patterns]="customPattern" mask="S{100}" [specialCharacters]="['space']" matInput [(ngModel)]="AnalisisPF.cotizacion.marca">
                    <!-- <mat-error *ngIf="submit && !Analisis.marca">Campo obligatorio</mat-error> -->
                </div>

                <div class="input">
                    <label>Plazo</label>
                    <mat-radio-group [(ngModel)]="AnalisisPF.cotizacion.plazo" [disabled]="true">
                        <mat-radio-button (click)="false" labelPosition="before" [value]="12">12 meses</mat-radio-button>
                        <mat-radio-button (click)="false" labelPosition="before" [value]="18">18 meses</mat-radio-button>
                        <mat-radio-button (click)="false" labelPosition="before" [value]="24">24 meses</mat-radio-button>
                        <mat-radio-button (click)="false" labelPosition="before" [value]="36">36 meses</mat-radio-button>
                        <mat-radio-button (click)="false" labelPosition="before" [value]="48">48 meses</mat-radio-button>
                        <mat-radio-button (click)="false" labelPosition="before" [value]="60">60 meses</mat-radio-button>
                    </mat-radio-group>
                </div>

                <div class="input">
                    <label>Factor de cotización</label>
                    <input mask="separator.2" thousandSeparator="," suffix=" %" readonly [(ngModel)]="AnalisisPF.cotizacion.factor_porcentaje">
                </div>

                <div class="input">
                    <label>Garantia</label>
                    <mat-select [(ngModel)]="AnalisisPF.cotizacion.garantia"placeholder="Seleccionar...">
                        <mat-option value="3">3 meses</mat-option>
                        <mat-option value="6">6 meses</mat-option>
                        <mat-option value="12">12 meses</mat-option>
                       
                    </mat-select>
                    <!-- <mat-error *ngIf="submit && !Analisis.garantia">Campo obligatorio</mat-error> -->
                </div>

                <div class="input">
                    <label>Tiempo de entrega</label>
                    <mat-radio-group [(ngModel)]="AnalisisPF.cotizacion.tiempo_entrega" [disabled]="true">
                        <mat-radio-button [value]="0">Inmediato</mat-radio-button>
                        <mat-radio-button [value]="1">10 a 30 días</mat-radio-button>
                        <mat-radio-button [value]="2">31 a 60 días</mat-radio-button>
                        <mat-radio-button [value]="3">61 a 90 días</mat-radio-button>
                        <!-- <mat-radio-button [value]="4">91 a 120 días</mat-radio-button> -->
                    </mat-radio-group>
                    <mat-error *ngIf="submit && !(AnalisisPF.cotizacion.tiempo_entrega >= 0)">Campo obligatorio</mat-error>
                </div>
            </div>

            <div>
                <div class="input">
                    <label>% Pago inicial</label>
                    <input mask="separator.2" thousandSeparator="," suffix=" %" [(ngModel)]="AnalisisPF.cotizacion.rentas_anticipadas" readonly>
                </div>

                <div class="input">
                    <label>Total pago inicial</label>
                    <input mask="separator.2" thousandSeparator="," prefix="$ " [(ngModel)]="AnalisisPF.colateral.pago_inicial" (input)="AnalisisPF.cotizacion.mar_total = AnalisisPF.cotizacion.monto_arrendar - AnalisisPF.colateral.pago_inicial" readonly>
                </div>
    
                <div class="input">
                    <label>Valor residual</label>
                    <input mask="separator.2" thousandSeparator="," prefix="$ " [(ngModel)]="AnalisisPF.cotizacion.valor_residual" readonly>
                </div>
    
                <div class="input">
                    <label>Mensualidad</label>
                    <input mask="separator.2" thousandSeparator="," prefix="$ " [(ngModel)]="AnalisisPF.cotizacion.mensualidad" (input)="AnalisisPF.colateral.factor = AnalisisPF.cotizacion.plazo * AnalisisPF.cotizacion.mensualidad" readonly>
                </div>
    
                <div class="input">
                    <label>Valor futuro</label>
                    <input mask="separator.2" thousandSeparator="," prefix="$ " [(ngModel)]="AnalisisPF.colateral.factor" readonly>
                </div>

                <div class="input">
                    <label>MAR Total</label>
                    <input readonly matInput mask="separator.2" thousandSeparator="," prefix="$ " style="width: 200px; background-color: #C4C4C4;" [(ngModel)]="AnalisisPF.cotizacion.mar_total">
                </div>
            </div>

            <div><span class="circle">3</span></div><div></div>
            <div style="width: 100%!important;">
                <tbody class="formulario analisis">
                    <tr>
                        <td></td>
                        <td></td>
                        <td>Puntuación</td>
                        <td rowspan="6">
                            <div class="puntuacion small">{{AnalisisPF.colateral.puntuacion_colateral}} puntos</div>
                        </td>
                    </tr>
                    <tr>
                        <td>Vida útil</td>
                        <td><input mask="separator.2" suffix=" años" matInput [(ngModel)]="AnalisisPF.caracteristica_activo.vida_util" (input)="CambiarPuntuacionColateral()" ></td>
                            <!-- <mat-error *ngIf="submit && !Analisis.vida_util">Campo obligatorio</mat-error></td> -->
                        <td><input matInput type="number" (input)="PuntuacionColateral()" [(ngModel)]="AnalisisPF.caracteristica_activo.vida_util_pts">                        
                    </tr>
                    <tr>
                        <td>Mercado Secundario</td>
                        <td><select style="width: 90%; height: 30px;" [(ngModel)]="AnalisisPF.caracteristica_activo.mercado_secundario" (change)="CambiarPuntuacionColateral()">
                            <option value="">Selecciona una opción</option>
                            <option value="BUENO">BUENO</option>
                            <option value="REGULAR">REGULAR</option>
                            <option value="MALO">MALO</option>
                          </select>
                        </td>
                            <!-- <mat-error *ngIf="submit && !Analisis.mercado_secundario">Campo obligatorio</mat-error></td> -->
                        <td>
                            <input matInput type="number" (input)="PuntuacionColateral()" [(ngModel)]="AnalisisPF.caracteristica_activo.mercado_secundario_pts">
                        </td>
                    </tr>
                    <tr>
                        <td>Estimado de Colocación</td>
                        <td><input mask="000" suffix=" días" matInput [(ngModel)]="AnalisisPF.caracteristica_activo.estimado_de_colocacion" (input)="CambiarPuntuacionColateral()"></td>
                            <!-- <mat-error *ngIf="submit && !AnalisisPF.caracteristica_activo.estimado_de_colocacion">Campo obligatorio</mat-error></td> -->
                        <td><input matInput type="number" (input)="PuntuacionColateral()" [(ngModel)]="AnalisisPF.caracteristica_activo.estimado_de_colocacion_pts"></td>
                    </tr>
                    <tr>
                        <!-- 0 5 3 5 5 -->
                        <td>Ubicación</td>
                        <td><select style="width: 90%; height: 30px;" [(ngModel)]="AnalisisPF.caracteristica_activo.ubicacion" (change)="CambiarPuntuacionColateral()">
                            <option value="1">Selecciona una opción</option>
                            <option value="2">Consultorio, clínica, hospital o gabinete</option>
                            <option value="3">Portátil</option>
                            <option value="4">Automóvil</option>
                            <option value="5">Equipo de Cómputo</option>
                          </select>
                        </td>
                            <!-- <mat-error *ngIf="submit && !Analisis.ubicacion">Campo obligatorio</mat-error></td> -->
                        <td><input matInput type="number" (input)="PuntuacionColateral()" [(ngModel)]="AnalisisPF.caracteristica_activo.ubicacion_pts"></td>
                    </tr>
                    <tr>
                        <td>Tipo de Financiamiento</td>
                        <td><input [patterns]="customPattern" mask="S{100}" [specialCharacters]="['space']" [(ngModel)]="AnalisisPF.caracteristica_activo.tipo_financiamient" (input)="CambiarPuntuacionColateral()"></td>
                            <!-- <mat-error *ngIf="submit && !Analisis.tipo_financiamient">Campo obligatorio</mat-error></td> -->
                        <td><input matInput type="number" (input)="PuntuacionColateral()" [(ngModel)]="AnalisisPF.caracteristica_activo.tipo_financiamiento_pts"></td>
                    </tr>
                </tbody>
            </div>


            <div style="width: 100%; display: flex; flex-direction: row; justify-content: center; align-items: center; margin-top: 40px;">
                <div ><b>Puntuacion total</b></div>

                <span class="puntuacion" style="margin-top: 0;">{{ AnalisisPF.puntuacion_total }} / 100</span>
                <!-- <div class="input" style="padding: 0 10px; box-sizing: border-box;"> -->
                    <!-- <label>Comentarios colateral y condiciones</label>
                    <textarea maxlength="500" placeholder="comentarios" [(ngModel)]="AnalisisPF.colateral.comentarios_colateral" rows="5"> </textarea> -->
                    <!-- <mat-error *ngIf="submit && !Analisis.comentarios_colateral">Campo obligatorio</mat-error> -->
                <!-- </div> -->
            </div>
           
            <br>
            <div style="width: 100%; display: flex; flex-direction: row; justify-content: center;">
                <button mat-icon-button (click)="enviarEmail()">
                   <mat-progress-spinner *ngIf="loading" diameter="25" mode="indeterminate"></mat-progress-spinner> <svg *ngIf="!loading" style="height: 60px; width:auto;" xmlns="http://www.w3.org/2000/svg" width="116.322" height="116.322" viewBox="0 0 116.322 116.322"><defs><style>.a{fill:#00a5da;}.b{fill:#fff;}</style></defs><g transform="translate(-902 -3389)"><g transform="translate(739 1848)"><path class="a" d="M58.161,0A58.161,58.161,0,1,1,0,58.161,58.161,58.161,0,0,1,58.161,0Z" transform="translate(163 1541)"/></g><g transform="translate(896.596 3947.768)"><path class="b" d="M41.4-500.669q0-10.725,0-21.45a5.963,5.963,0,0,1,4.633-6.142,6.565,6.565,0,0,1,1.48-.165q10.753-.015,21.506-.009a1.767,1.767,0,0,1,1.333.539q7.188,7.155,14.4,14.284a2.217,2.217,0,0,1,.688,1.678q0,11.805,0,23.611c0,3.1.011,6.208-.006,9.312a5.921,5.921,0,0,1-4.568,5.912,7.2,7.2,0,0,1-1.645.175q-15.825.016-31.649.008a5.957,5.957,0,0,1-6.169-6.137c-.014-6.374,0-12.748,0-19.122v-2.494Zm25.685-24.262c-.148-.019-.22-.036-.292-.036q-9.671,0-19.342,0A2.322,2.322,0,0,0,45-522.431q0,21.753,0,43.507a2.643,2.643,0,0,0,.1.761,2.374,2.374,0,0,0,2.567,1.667q12.553,0,25.106,0c2.18,0,4.36.008,6.54,0a2.2,2.2,0,0,0,2.425-2.341q0-15.435-.006-30.87c0-.179-.017-.357-.028-.579h-.917c-2.586,0-5.173.011-7.759,0a5.9,5.9,0,0,1-5.841-4.915,11.06,11.06,0,0,1-.1-1.819C67.083-519.649,67.089-522.271,67.089-524.931Zm3.577,2.755.11-.152c-.006.122-.016.243-.016.365,0,1.845-.008,3.69,0,5.535a2.4,2.4,0,0,0,2.662,2.675c1.79.01,3.579,0,5.369,0,.141,0,.282-.022.6-.049Z"/><path class="b" d="M112.862-402.662a20.413,20.413,0,0,1,3.467.541,5.619,5.619,0,0,1,3.76,6.088,5.838,5.838,0,0,1-4.969,5.135,34.168,34.168,0,0,1-4.2.1,1.094,1.094,0,0,1-1.112-1.2q-.012-4.652,0-9.3a1.129,1.129,0,0,1,1.259-1.22c.591-.008,1.182,0,1.772,0Zm-.617,2.613v6.977c.7,0,1.359.009,2.02,0a3.353,3.353,0,0,0,3.414-2.793,3.427,3.427,0,0,0-2.6-4A17.845,17.845,0,0,0,112.245-400.049Z" transform="translate(-51.359 -94.439)"/><path class="b" d="M73.008-401.922a31.835,31.835,0,0,1,4.288.037,3.9,3.9,0,0,1,3.213,4.357,3.981,3.981,0,0,1-3.85,3.59c-.419.019-.839,0-1.311,0v3.741h-2.34Zm2.355,5.573c.459,0,.863.011,1.266,0a1.572,1.572,0,0,0,1.533-1.394A1.558,1.558,0,0,0,77-399.417a9.164,9.164,0,0,0-1.641-.019Z" transform="translate(-23.73 -94.95)"/><path class="b" d="M164.64-402.1v2.4h-4.906v2.322h4.444V-395h-4.466v4.724h-2.38v-1.6q0-4.348,0-8.7c0-1.141.384-1.529,1.516-1.528C160.764-402.1,162.68-402.1,164.64-402.1Z" transform="translate(-87.046 -94.862)"/></g></g></svg>
                </button>
            </div>
        </div>
        <button class="next-button" mat-button (click)="NextPage()" matStepperNext>
            Guardar
            <!-- <mat-icon>navigate_next</mat-icon> -->
            <svg style="height: 20px; width:auto;"  xmlns="http://www.w3.org/2000/svg" width="31.25" height="31.25" viewBox="0 0 31.25 31.25"><defs><style>.next{fill:#00a5da;}</style></defs><path class="next" d="M15.625,0A15.625,15.625,0,1,0,31.25,15.625,15.626,15.626,0,0,0,15.625,0Zm-1.3,24.74V12.173L8.755,17.741l-2.21-2.21,9.079-9.081,9.081,9.081-2.21,2.21-5.569-5.568V24.74Z" transform="translate(31.25) rotate(90)"/></svg>
        </button>
    </div>

    <app-socials-footer style="width: 100%;"></app-socials-footer>
</div>